import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { ButtonLink } from '../components/ui/ButtonLink';
export function NotFound() {
  usePageTitle('Pagina niet gevonden');
  return <section className="flex min-h-[80vh] w-full items-center bg-ink pt-20" data-id="element-407" data-mp="105d01zado35g">
      <div className="mx-auto max-w-7xl px-5 md:px-10" data-id="element-408" data-mp="1087gzgu6n5u4">
        <p className="font-serif text-8xl italic text-amber" data-id="element-409" data-mp="155qx6mafxsop">Valse noot.</p>
        <h1 className="mt-6 max-w-xl font-serif text-4xl text-paper" data-id="element-410" data-mp="1a4u2m7uc20x7">Deze pagina bestaat niet (meer).</h1>
        <ButtonLink to="/" arrow className="mt-10" data-id="element-411" data-mp="1f23pbfqc7yhc">
          Terug naar home
        </ButtonLink>
      </div>
    </section>;
}